export const createTrackingHandler = Odigeo => ({
  trackPage: (page, data = {
    customDimensions: {},
    error: undefined,
    eCommerce: undefined,
    funnel: true,
    legacy: undefined
  }) => {
    Odigeo.trigger('analytics:tracking', {
      type: 'trackVirtualPage',
      data: {
        page,
        ...data
      }
    });
    Odigeo.trigger('tagCommander:pageLoaded', {
      page: page
    });
  },
  trackSurvey(eventName) {
    Odigeo.trigger('frontend-shell:qualtrics', eventName);
  }
});